import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["type", "is", "as", "children"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _Array$isArray from "@babel/runtime-corejs3/core-js-stable/array/is-array";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import React, { useMemo, forwardRef } from 'react';
import { StyleSheet, useStyles } from '@rexlabs/styling';
import { useText } from './provider';

var mapTextTypes = function mapTextTypes(text, type) {
  return _Array$isArray(type) ? _reduceInstanceProperty(type).call(type, function (acc, t) {
    return _objectSpread(_objectSpread({}, acc), text[t]);
  }, {}) : text[type];
};

/**
 * The Text component, together with the TextProvider, let's you define a range of atomic text styles
 * and apply them to a text element in any combination. The package also provides some commonly used
 * presets as variant components with specific props controlling those atomic styles available to them
 */
export var Text = /*#__PURE__*/forwardRef(function Text(_ref, ref) {
  var type = _ref.type,
      IsEl = _ref.is,
      _ref$as = _ref.as,
      AsEl = _ref$as === void 0 ? 'p' : _ref$as,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var text = useText();
  var styles = useMemo(function () {
    var textStyles = mapTextTypes(text, type);
    return StyleSheet({
      container: textStyles
    });
  }, [text, type]);
  var s = useStyles(styles, 'Text');
  var El = IsEl || AsEl;
  return /*#__PURE__*/React.createElement(El, _extends({}, props, s.with('container')(props), {
    ref: ref
  }), children);
});
export default Text;